import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from '../../../core/modelos/user';
import { UsuariosService } from '../usuarios/usuarios.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { fuseAnimations } from '../../../core/animations';

@Component({
    selector: 'fuse-perfil-usuario',
    templateUrl: './perfil-usuario.component.html',
    styleUrls: ['./perfil-usuario.component.scss'],
    animations   : fuseAnimations
})
export class PerfilUsuarioComponent implements OnInit {

    // Formulario
    formulario: FormGroup;

    usuario: User;

    loading = true;

    selectedFiles: FileList;
    foto;

    constructor(
        private fb: FormBuilder,
        private usuariosService: UsuariosService,
        private notificaciones: NotificacionesService
    ) { }

    ngOnInit() {
        this.getUsuario(+JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario.id);
    }

    getUsuario(id: number) {
        this.usuariosService.getUsuario(id).subscribe(
            data => {
                if (data.success) {
                    this.usuario = data.items;
                    this.usuario.foto = this.usuario.foto ? 'data:image/jpeg;base64,' + this.usuario.foto : this.usuario.foto;
                    this.loading = false;
                    this.crearFormulario();
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOObtenido);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {

        this.formulario = this.fb.group({
            nombre: [this.usuario.nombre, Validators.required],
            apellidos: [this.usuario.apellidos, Validators.required],
            email: [this.usuario.email],
        });
    }

    onSubmit(): void {
        this.usuario = this.prepararModelo();
        // Hay que subirlo sin el 'data:image/jpeg;base64,'
        this.usuario.foto = this.foto;
            this.usuariosService.updateUsuario(this.usuario).subscribe(
                data => {
                    if (data.success) {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioEditado);
                    } /* else if (data.message) {
                        this.validacion = data.message;
                    } */
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOEditado);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    // if (err.error.message) {
                    //     this.validacion = err.error.message;
                    // }
                }
            );

    }

    prepararModelo(): User {
        const formModel = this.formulario.value;

        const saveUser: User = {
            id: this.usuario.id,
            nombre: formModel.nombre,
            apellidos: formModel.apellidos,
            email: formModel.email,
            rol: this.usuario.rol,
            cliente: this.usuario.cliente
        };

        return saveUser;
    }

    selectFile(event) {
        // Recoge la imagen que quiere subir el usuario y la guardo en this.foto con el formato adecuado
        this.selectedFiles = event.target.files;
        const reader = new FileReader();
        const file = this.selectedFiles.item(0);
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.foto = reader.result.split(',')[1];
            this.usuario.foto = 'data:image/jpeg;base64,' + this.foto; // Para que actualice en pantalla también
        };

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/perfil-usuario/perfil-usuario.component.ts